module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1609970010001"
    }
  }), _c('h2', {
    staticClass: "chapter-title"
  }, [_vm._v("Shabby chic")]), _c('a', {
    attrs: {
      "id": "p9000f1609930010001"
    }
  }), _c('div', {
    staticClass: "epigraph-group"
  }, [_c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Every girl needs a handbag they can rely on which will hold all your essentials, such as lippy, purse, keys and emergency snacks, but which will also look stylish with whatever you are wearing. This classic tote bag is the simplest bag to make ever. Suitable for even the most unsure beginner, you can make this bag in any fabric, in any colour and in any size to match every outfit!")])]), _c('a', {
    attrs: {
      "id": "p9000f1609960010005"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g10005.png",
      "width": "25.40835%"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1609960010001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g10001.png",
      "width": "22.86751%"
    }
  }), _c('div', {
    staticClass: "caption-group"
  }, [_c('p', {
    staticClass: "captionpara"
  }, [_vm._v("Lace and ribbon ")])])]), _c('a', {
    attrs: {
      "id": "p9000f1609960010002"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g10003.png",
      "width": "23.23049%"
    }
  }), _c('div', {
    staticClass: "caption-group"
  }, [_c('p', {
    staticClass: "captionpara"
  }, [_vm._v("Simply dotty ")])])]), _c('p', {
    staticClass: "para-header-left"
  }, [_vm._v("LOVE THE LOOK?")]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Follow the same design to create loads of different styles of bag with different materials and textures, for example swirly patterns sewn in, fabric floral embellishments and attention-grabbing materials (see pages 14–21).")]), _c('a', {
    attrs: {
      "id": "p9000f1609960010003"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g10002.png",
      "width": "23.23049%"
    }
  }), _c('div', {
    staticClass: "caption-group"
  }, [_c('p', {
    staticClass: "captionpara"
  }, [_vm._v("Sweet treat ")])])]), _c('a', {
    attrs: {
      "id": "p9000f1609960010004"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g10004.png",
      "width": "23.23049%"
    }
  }), _c('div', {
    staticClass: "caption-group"
  }, [_c('p', {
    staticClass: "captionpara"
  }, [_vm._v("Funky florals")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1609960011001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g11001.png",
      "width": "89.2922%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1609970012001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_vm._v("fabulous fabric")]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Choose two contrasting fabrics which work well together. I’ve chosen a floral cotton fabric with a retro feel, and matched it with a cotton spotted fabric in green. Both the fabrics should be made out of the same fabric (e.g. cotton). They are also paired with a bright yellow cotton as a lining fabric – for linings you can be as bold as you like with colour to really make it stand out when you peek inside the bag! ")]), _c('a', {
    attrs: {
      "id": "p9000f1609960012001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g12001.png",
      "width": "61.34301%"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1609960012002"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "para-header-left"
  }, [_c('strong', [_vm._v("bag the essentials:")])]), _c('div', {
    staticClass: "list-step1-group"
  }, [_c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Floral cotton fabric")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Green spotted cotton fabric")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Yellow cotton fabric")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Red gingham ribbon, 1.5cm ("), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/8541.jpg"
    }
  }), _vm._v("in) width")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Red gingham ribbon, 0.5cm ("), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p4.png"
    }
  }), _vm._v("in) width")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" 2 bamboo ‘D’ shape handles")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Cream machine thread")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Basic bag kit")]), _c('p', {
    staticClass: "indentpara"
  }, [_vm._v("(see page 101)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_c('strong', [_vm._v("finished size")]), _vm._v(" 30 × 23.5cm "), _c('br'), _vm._v("(12 × 9in)")])]), _c('a', {
    attrs: {
      "id": "p9000f1609960012005"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g12004.png",
      "width": "33.75681%"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1609960012003"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g12002.png",
      "width": "45.37205%"
    }
  })]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("1 Cut two pieces of floral fabric, each 26 × 24cm (10 ×"), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p2.png"
    }
  }), _vm._v("in), then trim two pieces of green spotted fabric, each 26 × 11cm (10 ×"), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p3.png"
    }
  }), _vm._v("in). Cut two pieces of yellow fabric, which will be the lining of the bag, each 33 × 26cm (13 × 10in). Pin the floral fabric to the green spotted fabric along the 26cm (10in) edge, right sides together, and sew. Open the seams and press with an iron.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p9000f1609960012004"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g12003.png",
      "width": "45.37205%"
    }
  })]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("2 Cut two lengths of red gingham ribbon with a width of 1.5cm ("), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/8541.jpg"
    }
  }), _vm._v("in), each 26cm (10in). Use fabric glue to carefully stick the ribbon along the join of the fabrics and leave to dry completely.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1609960013001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g13001.png",
      "width": "45.37205%"
    }
  })]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("3 When dry, place the front and back panels of the bag together, right sides facing each other and pin along the sides and bottom. Sew these three sides together. Do the same with the lining fabric.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p9000f1609960013002"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g13002.png",
      "width": "45.37205%"
    }
  })]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("4 Turn the bag through to the right side and press flat. Keep the lining inside out. Push the lining inside the bag and smooth so it fits properly. Fold the top edge of the bag over two times so that it covers the lining and there are no raw edges showing. Press with the iron and pin in place. Sew around the top edge.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p9000f1609960013003"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g13003.png",
      "width": "45.73503%"
    }
  })]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("5 Cut four lengths of the 0.5cm ("), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p5.png"
    }
  }), _vm._v("in) width red gingham ribbon, each 10cm (4in) long. Carefully thread each length through the hole at the bottom of the bamboo handles.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p9000f1609960013004"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g13004.png",
      "width": "45.73503%"
    }
  })]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("6 Pin the ribbons that hold the handles in place at the top of the bag, inside the opening and secure with small stitches.")]), _c('a', {
    attrs: {
      "id": "p9000f1609960013006"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "para-header-left"
  }, [_vm._v("ARM CANDY")]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Make sure that the two fabrics you choose to use for the outside of the bag match well and are of a similar texture and weight.")]), _c('a', {
    attrs: {
      "id": "p9000f1609960013005"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g13005.png",
      "width": "12.70417%"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1609970014001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_vm._v("Funky florals")]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("This bag is maybe the simplest bag to make – the front and back panels are made from bought place mats, which are the ideal size for this bag. Simply sew them together along three sides, add straps and voila! At last you can have a bag which is big enough to hold all your favourite magazines, so you are never behind on what’s happening in the world of celebdom.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("1 Take one of the fabric place mats and decorate the front by tracing a leaf pattern (see page 119) onto bondaweb and ironing onto the back of red floral fabric. Cut out and then iron down the right-hand side of the front panel of the bag.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("2 Trace two flower shapes (see page 119) onto bondaweb and iron onto the back of plain red fabric. Cut out and iron on top of the leaf shapes. Stitch buttons in the centre of the flowers with red embroidery thread. Place the front and back panels of the bag together and pin along the sides and bottom, then stitch.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("3 Use fabric glue to stick a length of red ric rac braid along the top edges of the bag and wait until dry. Pin and stitch red bias binding ribbon along the sides and bottom of the bag.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("4 Cut two lengths of pale blue grosgrain ribbon, 1.5cm ("), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/8541.jpg"
    }
  }), _vm._v("in) in width, each 65cm (26in), and stitch inside the top edges of the bag, to make straps.")]), _c('a', {
    attrs: {
      "id": "p9000f1609960014001"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "para-header-left"
  }, [_c('strong', [_vm._v("bag the essentials:")])]), _c('div', {
    staticClass: "list-step1-group"
  }, [_c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" 2 fabric place mats, blue and white floral print")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Red cotton fabric")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Red floral print fabric")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Red bias binding")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Red ric rac braid")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" 2 white buttons")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Pale blue grosgrain ribbon, 1.5cm ("), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/8541.jpg"
    }
  }), _vm._v("in) wide")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Red embroidery thread")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Red sewing machine thread")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Basic bag kit")]), _c('p', {
    staticClass: "indentpara"
  }, [_vm._v("(see page 101)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_c('strong', [_vm._v("finished size")]), _vm._v(" 38 × 33.5cm "), _c('br'), _vm._v("(15 × 13"), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p5.png"
    }
  }), _vm._v("in)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p9000f1609960014004"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "para-header-left"
  }, [_vm._v("ARM CANDY")]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Choose a large print, as the bag is fairly large, and stick to a simple colour scheme – two colours for the background (blue and white) and a bright colour for contras  (in this case, red).")]), _c('a', {
    attrs: {
      "id": "p9000f1609960014003"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g14002.png",
      "width": "13.06715%"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p9000f1609960014002"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g14001.png",
      "width": "90.38113%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1609960015001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g15001.png",
      "width": "87.47731%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1609970016001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_vm._v("Lace and ribbon")]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Be the envy of all your friends with a pretty quilted bag. Quilting isn’t nearly as tricky as it looks and the results are fantastic! Use buttons to make the simple flower motif on the front and keep colours to a minimum. The fabric used to make this bag already had strips of ribbon stitched onto it but you can achieve the same effect by sewing ribbons onto plain white cotton.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("1 Make a paper template for the shape of the bag (see page 117) and cut out two pieces for the front and back, plus two pieces in plain white cotton for the lining. Also cut out two pieces of thin wadding to the same size. Pin all three layers together, with the wadding in between the front fabric and the lining.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("2 On a sewing machine, drop the feed dog and sew swirly patterns freehand to give a quilted look. Alternatively you could quilt the fabrics by sewing tiny running stitched swirls. Do this on both the front and back panels. At the bottom right-hand corner of the front panel sew a large red button with six small white buttons around it so that it looks like a flower.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("3 Sew small red running stitches around the outside of the buttons to give the flower a more def nite shape. Fold the top edges of the front and back panels twice and sew to make a neat hem. Place the front and back pieces together, right sides facing each other, pin along the sides and bottom, and sew.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("4 Finish by stitching a handle made of clear plastic beads threaded onto thin wire at either side of the bag.")]), _c('a', {
    attrs: {
      "id": "p9000f1609960016001"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "para-header-left"
  }, [_c('strong', [_vm._v("bag the essentials:")])]), _c('div', {
    staticClass: "list-step1-group"
  }, [_c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" White cotton fabric with pre-stitched ribbons")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Plain white cotton fabric")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Wadding, thin")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" White machine embroidery thread")]), _vm._v(" "), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Large red button")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" 6 small white buttons")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Red embroidery thread")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Clear plastic bead handle")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Basic bag kit")]), _c('p', {
    staticClass: "indentpara"
  }, [_vm._v("(see page 101)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_c('strong', [_vm._v("finished size")]), _vm._v(" 23.5 × 25cm "), _c('br'), _vm._v("(9¾ × "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9.png"
    }
  }), _vm._v("in)")])]), _c('a', {
    attrs: {
      "id": "p9000f1609960016003"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "para-header-left"
  }, [_vm._v("ARM CANDY")]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("If you can’t find handles made from large clear beads like this one, simply buy beads and thread them onto thin jewellery wire to make your own version.")]), _c('a', {
    attrs: {
      "id": "p9000f1609960016002"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g16002.png",
      "width": "13.43013%"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p9000f1609960016004"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g16001.png",
      "width": "68.96552%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1609960017001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g17001.png",
      "width": "87.84029%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1609970018001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_vm._v("Simply dotty")]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Bold patterns are the next big thing in bags. Using brightly coloured felt and beads on this neutral coloured bag really gives it a lift. Make sure you also choose a bright contrasting fabric for the lining too.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("1 Cut two pieces of stone spotted fabric 19 × 22cm (7.5 × "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p10.png"
    }
  }), _vm._v("in), and two pieces of stone floral fabric 10 × 22cm (4 × "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p10.png"
    }
  }), _vm._v("in). Cut two pieces of bright pink cotton fabric for the lining, 27 × 22cm ("), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p11.png"
    }
  }), _vm._v(" × "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p10.png"
    }
  }), _vm._v("in). This bag is made up in the same way as the shabby chic tote bag on page 10.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("2 Sew large stitches in pink embroidery thread along the join of the two fabrics at the front, and a row of pink running stitch along the top edge of the bag. Use the templates (see page 117) to cut two flowers out of felt, one in turquoise and one in lime green.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("3 Sew blanket stitch around the edge of the turquoise flower in orange thread and running stitch along the centre of the lime green petals. Cut out a bright pink circle to go in the centre of the flower (see page 117) and sew running stitch around the edge in turquoise thread. Take a small orange felt ball and sew red seed beads onto it, with a turquoise sequin with a red bead on it at the top. This will go at the centre of the flower.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("4 Stitch the finished flower onto the bag. Sew a large pink felt ball with orange seed beads in the top centre. Sew pink running stitch along the centre of a 14cm (5.5in) length of cream cotton woven ribbon. Stitch at the top of the back panel to make a loop to fasten onto the pink ball. Cut a 120cm (47in) length of the same ribbon and sew pink running stitch along the middle. Sew this at the sides to make a long strap. Thread several felt balls together and decorate with seed beads to make a bag charm.")]), _c('a', {
    attrs: {
      "id": "p9000f1609960018001"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "para-header-left"
  }, [_c('strong', [_vm._v("bag the essentials:")])]), _c('div', {
    staticClass: "list-step1-group"
  }, [_c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Stone coloured spotted cotton fabric")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Stone floral cotton fabric")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Hot pink cotton fabric")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Felt in turquoise, orange, lime and hot pink")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Felt balls, various sizes, same colours as felt")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Embroidery thread in hot pink, turquoise and orange")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Seed beads and sequins, bright colours")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Cotton woven ribbon, cream")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Cream sewing machine thread")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Basic bag kit")]), _c('p', {
    staticClass: "indentpara"
  }, [_vm._v("(see page 101)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_c('strong', [_vm._v("finished size")]), _vm._v(" 24 × 20cm "), _c('br'), _vm._v("("), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p12.png"
    }
  }), _vm._v(" × "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p13.png"
    }
  }), _vm._v("in)")])]), _c('a', {
    attrs: {
      "id": "p9000f1609960018002"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g18001.png",
      "width": "45.37205%"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1609960018004"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "para-header-left"
  }, [_vm._v("ARM CANDY")]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("When at attching the strap for this bag, make sure it’s the right length for you by pinning it first and trying it on before you stitch it in place.")]), _c('a', {
    attrs: {
      "id": "p9000f1609960018003"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g18002.png",
      "width": "13.06715%"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1609960019001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g19001.png",
      "width": "86.38838%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1609970020001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_vm._v("Sweet treat")]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("This delicious-looking handbag looks good enough to eat! To stop this being too ‘cutesy’ I’ve used a grey felt to make the bag, and added sweet looking fabric and beads to add decoration. The candy striped handles also add to the fun theme of the bag and lighten the severity of the grey background. As it’s made out of felt there’s no need for hemming, as felt doesn’t fray and is extremely easy to use. The details really make the bag, so spend time choosing beads, buttons and fabrics carefully.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("1 Make a paper template (see page 120) for the shape of the bag, with the top edge 21.5cm ("), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/p14.png"
    }
  }), _vm._v("in) and a depth of 17cm (6.5in). Use the template to cut out two pieces of thick grey felt. Trace the shapes needed for the cupcake (see page 121) onto bondaweb and then iron onto the back of the relevant fabrics (white felt for the icing, beige felt for the cake, pink spotted cotton for the case).")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("2 Cut out the shapes and position onto the front of one of the grey felt pieces and iron to fix in place. Hand stitch around the edges of the shapes and to make the stripes on the case. Sew a few multi-coloured seed beads onto the icing and stitch a red button on the top like a cherry.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("3 Along the top edge of the bag, sew a row of small white buttons using pink thread. Place a length of ruffled pink and white striped ribbon between the front and back panels of the bag, pin and stitch. Cut four lengths of pale pink ribbon, 1cm (½in) width, and thread through the holes at the bottom of the striped plastic ‘D’ shaped handles. Stitch the ribbons at the top of the bag to secure the handles in place.")]), _c('a', {
    attrs: {
      "id": "p9000f1609960020001"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "para-header-left"
  }, [_c('strong', [_vm._v("bag the essentials:")])]), _c('div', {
    staticClass: "list-step1-group"
  }, [_c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Grey thick felt")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Craft felt in beige and white")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Pink spotted cotton fabric")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Embroidery thread in pink")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Seed beads, various colours")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Red button")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Several small white buttons")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Pink and white striped ‘D’ shaped handles")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Pale pink ribbon,1cm (½in) width")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Pink and white striped ruffle ribbon")]), _c('p', {
    staticClass: "hangingpara"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p1.png"
    }
  }), _vm._v(" Basic bag kit")]), _c('p', {
    staticClass: "indentpara"
  }, [_vm._v("(see page 101)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_c('strong', [_vm._v("finished size")]), _vm._v(" 18 × 23cm "), _c('br'), _vm._v("(7 × 9in)")])]), _c('a', {
    attrs: {
      "id": "p9000f1609960020002"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g20001.png",
      "width": "45.73503%"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1609960020004"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "para-header-left"
  }, [_vm._v("ARM CANDY")]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("You can afford to go over the top with cuteness on this bag – look out for beads and buttons that look like candies!")]), _c('a', {
    attrs: {
      "id": "p9000f1609960020003"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g20002.png",
      "width": "12.70417%"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1609960021001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g21001.png",
      "width": "87.47731%"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c506d30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch007.vue
// module id = 75
// module chunks = 0